/**
 * documentfunctions.js
 * Created by calhosh on 10/22/2020.
 */
export class DocumentFunctions {
	static onConfirmReasonChange(
		engagementId,
		documentId,
		documentChangeTypeId,
		documentExtensionId,
		documentChangeComment,
		executeExtensionActions,
		dispatch,
		updateDocument,
		updateDocumentChangeComment,
		createDocumentChangeComment
	) {
		return dispatch(
			updateDocument(engagementId, documentId, {
				documentChangeTypeId: documentChangeTypeId
			})
		).then(() => {
			if (executeExtensionActions) {
				return DocumentFunctions.changeCommentPersistFunction(
					engagementId,
					documentId,
					documentExtensionId,
					documentChangeComment,
					dispatch,
					updateDocumentChangeComment,
					createDocumentChangeComment
				);
			}
		});
	}

	static changeCommentPersistFunction(
		engagementId,
		documentId,
		documentExtensionId,
		documentChangeComment,
		dispatch,
		updateDocumentChangeComment,
		createDocumentChangeComment
	) {
		let data = {
			changeReason: documentChangeComment
		};

		if (documentExtensionId) {
			return dispatch(updateDocumentChangeComment(engagementId, documentId, documentExtensionId, data));
		} else {
			return dispatch(createDocumentChangeComment(engagementId, documentId, data));
		}
	}
}
